export default __webpack_public_path__ + "static/media/domino_counter_screen_3.ad8ee41b.png";